var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275838"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 588",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1879 16.1898C13.8752 18.5033 10.1248 18.5033 7.81157 16.1898C5.75871 14.1351 5.52812 10.9515 7.1195 8.64218L9.84243 11.3648C10.263 11.7871 10.9448 11.7871 11.3656 11.3648C11.7862 10.9428 11.7862 10.2618 11.3656 9.83986L8.64209 7.11723C10.9495 5.52767 14.1348 5.75607 16.1876 7.81078C18.5009 10.1243 18.5009 13.8763 16.1876 16.1898H16.1879ZM7.05015 7.04845C4.31662 9.78388 4.31662 14.217 7.05015 16.9482C9.78395 19.6839 14.2158 19.6839 16.9496 16.9482C19.6835 14.217 19.6835 9.78388 16.9496 7.04845C14.2161 4.31718 9.78395 4.31718 7.05015 7.04845Z",
    fill: "#1B1B1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3f3832ba8314c2b9a95a988e00d34778.svg";
export { ForwardRef as ReactComponent };